import { render, staticRenderFns, recyclableRender, components } from "./index.vue?vue&type=template&id=1575b33b&scoped=true&"
var renderjs
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1575b33b",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/nav/index.vue"
export default component.exports